const Divider = {
  styleOverrides: {},
};

export default Divider;
